import { render, staticRenderFns } from "./ModalRemoveFromCart.vue?vue&type=template&id=1ef93f20"
import script from "./ModalRemoveFromCart.vue?vue&type=script&lang=js"
export * from "./ModalRemoveFromCart.vue?vue&type=script&lang=js"
import style0 from "./ModalRemoveFromCart.vue?vue&type=style&index=0&id=1ef93f20&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports